import { ENDPOINTS } from 'utils/api/callApi'
import { IShipperRate } from 'apps/marketplace/store/shipperLane/types'
import { toShipperRatePayload } from 'apps/marketplace/utils/helpers/shipperRates'

export enum GET_SHIPPER_LANE_ACTIONS {
  GET_SHIPPER_LANE_REQUEST = 'GET_SHIPPER_LANE_REQUEST',
  GET_SHIPPER_LANE_SUCCESS = 'GET_SHIPPER_LANE_SUCCESS',
  GET_SHIPPER_LANE_FAILURE = 'GET_SHIPPER_LANE_FAILURE',
}
export const getShipperLane = (transfixShipperLaneId: string) => {
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.shipperRates,
        method: 'GET',
        params: {
          filters: {
            transfixShipperLaneId,
          },
          sortField: 'start_date',
          sortOrder: 'desc',
          includes: ['shipper_lane'],
        },
      },
      actionTypes: Object.keys(GET_SHIPPER_LANE_ACTIONS),
    },
    type: '',
  }
}

export enum CREATE_SHIPPER_RATE_ACTIONS {
  CREATE_SHIPPER_RATE_REQUEST = 'CREATE_SHIPPER_RATE_REQUEST',
  CREATE_SHIPPER_RATE_SUCCESS = 'CREATE_SHIPPER_RATE_SUCCESS',
  CREATE_SHIPPER_RATE_FAILURE = 'CREATE_SHIPPER_RATE_FAILURE',
}
export const createShipperRate = (params: IShipperRate) => {
  const payload = toShipperRatePayload(params)
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.shipperRates,
        method: 'POST',
        body: payload,
      },
      actionTypes: Object.keys(CREATE_SHIPPER_RATE_ACTIONS),
    },
    type: '',
  }
}

export enum UPDATE_SHIPPER_RATE_ACTIONS {
  UPDATE_SHIPPER_RATE_REQUEST = 'UPDATE_SHIPPER_RATE_REQUEST',
  UPDATE_SHIPPER_RATE_SUCCESS = 'UPDATE_SHIPPER_RATE_SUCCESS',
  UPDATE_SHIPPER_RATE_FAILURE = 'UPDATE_SHIPPER_RATE_FAILURE',
}
export const updateShipperRate = (params: IShipperRate) => {
  const payload = toShipperRatePayload(params)
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.shipperRates,
        id: params.id,
        method: 'PUT',
        body: payload,
      },
      actionTypes: Object.keys(UPDATE_SHIPPER_RATE_ACTIONS),
    },
    type: '',
  }
}

export enum ADD_SHIPPER_RATE_MODAL {
  ADD_SHIPPER_RATE_MODAL_OPEN = 'ADD_SHIPPER_RATE_MODAL_OPEN',
  ADD_SHIPPER_RATE_MODAL_CLOSE = 'ADD_SHIPPER_RATE_MODAL_CLOSE',
}

export const openAddShipperRateModal = (shipperRate?: IShipperRate) => ({
  type: ADD_SHIPPER_RATE_MODAL.ADD_SHIPPER_RATE_MODAL_OPEN,
  payload: { shipperRate },
})

export const closeAddShipperRateModal = () => ({
  type: ADD_SHIPPER_RATE_MODAL.ADD_SHIPPER_RATE_MODAL_CLOSE,
})

export const CLEAR_SHIPPER_LANE = 'CLEAR_SHIPPER_LANE'
export const clearShipperLane = () => ({
  type: CLEAR_SHIPPER_LANE,
})
